$(function() {
	var currentScroll = 0;
	$('body').on('click', '.web_catalog-nav-toggle', function() {

		if ( $('#web_catalog-nav').hasClass('is-open') ) {
			$('#web_catalog-nav').toggleClass("is-open");
		    $('.bg_web_catalog-nav').toggleClass("is-open");
		    $('body').toggleClass("is-open");
			window.scrollTo( 0 , currentScroll );

		} else {
			currentScroll = $(window).scrollTop();
			
			$('#web_catalog-nav').toggleClass("is-open");
		    $('.bg_web_catalog-nav').toggleClass("is-open");
		    $('body').toggleClass("is-open");

			$('body').css({
			  top: -1 * currentScroll
			});
		
		}

	    return false;
	});	
	
	$('body').on('click', '.bg_web_catalog-nav', function() {
		if ( $('#web_catalog-nav').hasClass('is-open') ) {
			$('#web_catalog-nav').toggleClass("is-open");
		    $('.bg_web_catalog-nav').toggleClass("is-open");
		    $('body').toggleClass("is-open");
			window.scrollTo( 0 , currentScroll );

		} else {
			currentScroll = $(window).scrollTop();
			
			$('#web_catalog-nav').toggleClass("is-open");
		    $('.bg_web_catalog-nav').toggleClass("is-open");
		    $('body').toggleClass("is-open");

			$('body').css({
			  top: -1 * currentScroll
			});
		
		}
      
        return false;
	});	

	$('body').on('click', '.web_catalog-nav_head', function() {
		if ( $('#web_catalog-nav').hasClass('is-open') ) {
			$('#web_catalog-nav').toggleClass("is-open");
		    $('.bg_web_catalog-nav').toggleClass("is-open");
		    $('body').toggleClass("is-open");
			window.scrollTo( 0 , currentScroll );

		} else {
			currentScroll = $(window).scrollTop();
			
			$('#web_catalog-nav').toggleClass("is-open");
		    $('.bg_web_catalog-nav').toggleClass("is-open");
		    $('body').toggleClass("is-open");

			$('body').css({
			  top: -1 * currentScroll
			});
		
		}
      
        return false;
	});	
	$('.nav_acdn dt').click(function(){
		$(this).toggleClass("is-open");
		$(this).next("dd").slideToggle();
	});	

})
